<template>
  <DsButton
    variant="bordered"
    theme="dark"
    shape="pill"
    size="40"
    class="shrink-0"
    :loading="loading"
    data-service-replay-copy-access-code="true"
    aria-label="Copy access code"
    @click="$emit('copy')"
  >
    <span class="flex items-center gap-[8px] whitespace-nowrap">
      {{ loading ? 'Preparing Code' : 'Share Access Code' }}
      <DesignSystemIcon v-if="!loading" name="copy" class="h-[16px] w-[16px]" aria-hidden="true" />
    </span>
  </DsButton>
</template>

<script>
import { Button as DsButton, Icon as DesignSystemIcon } from '@team-hogc/hogc-one-design-system';

export default {
  name: 'ShareAccessCodeSection',
  components: {
    DsButton,
    DesignSystemIcon,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['copy'],
};
</script>
